export type GradientStops = Array<RGB | RGBA | string>

type RGB = [number, number, number]
type RGBA = [number, number, number, number]

export function getColorStop(color: RGB | RGBA | string) {
	if (typeof color === "string") {
		return color
	}
	if (color.length === 4) {
		return `rgba(${(color[0] * 255) >> 0}, ${(color[1] * 255) >> 0}, ${
			(color[2] * 255) >> 0
		}, ${color[3]})`
	}
	if (color.length === 3) {
		return `rgb(${(color[0] * 255) >> 0}, ${(color[1] * 255) >> 0}, ${(color[2] * 255) >> 0})`
	}
	return "transparent"
}

export function linearGradient(gradientStops: GradientStops) {
	const stops = gradientStops.map(getColorStop)
	return `linear-gradient(90deg, ${stops.join(", ")})`
}
